function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M5,2C3.5,2,2.3,3.3,2.3,4.8S3.5,7.5,5,7.5c48.4,0,87.7,39.3,87.7,87.7c0,1.5,1.2,2.8,2.8,2.8s2.8-1.2,2.8-2.8 C98.2,43.8,56.4,2,5,2z"
}), React.createElement("path", {
  d: "M6.1,23.5c-1.5,0-2.8,1.2-2.8,2.8S4.5,29,6.1,29c35.9,0,65,29.2,65,65c0,1.5,1.2,2.8,2.8,2.8s2.8-1.2,2.8-2.8 C76.6,55.1,44.9,23.5,6.1,23.5z"
}), React.createElement("path", {
  d: "M5.7,43.6c-1.5,0-2.8,1.2-2.8,2.8s1.2,2.8,2.8,2.8c24.8,0,45,20.2,45,45c0,1.5,1.2,2.8,2.8,2.8s2.8-1.2,2.8-2.8 C56.3,66.3,33.6,43.6,5.7,43.6z"
}), React.createElement("path", {
  d: "M5.8,64C4.2,64,3,65.3,3,66.8s1.2,2.8,2.8,2.8c13.4,0,24.4,10.9,24.4,24.4c0,1.5,1.2,2.8,2.8,2.8s2.8-1.2,2.8-2.8 C35.6,77.5,22.2,64,5.8,64z"
}), React.createElement("ellipse", {
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -61.3424 32.8708)",
  cx: 9,
  cy: 90.5,
  rx: 7.2,
  ry: 7.2
}));

var SvgRssFeed = function SvgRssFeed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_2_1_",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRssFeed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rss-feed.14a5b53f.svg";
export { ForwardRef as ReactComponent };